import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NEW_USER } from '../../../constants/routes.json';

const style = {
    'min-height': '600px',
    'background-image': '',
    'background-size': 'cover',
    'background-position': 'center top'
}

export default class Header extends Component {
    render() {
        return (
            <div class="header bg-danger py-6">
                <div class="container-fluid">
                    <div class="header-body">
                        <div class="row align-items-center py-4">
                            <div class="col-lg-6 col-7">
                                <h6 class="h2 text-white d-inline-block mb-0">Usuários</h6>
                            </div>
                            <div class="col-lg-6 col-5 text-right">
                                <Link to={NEW_USER} class="btn btn-sm btn-default">Cadastrar</Link>
                                {/* <a href="#" class="btn btn-sm btn-neutral">Filtros</a> */}
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Users/Header.js